import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { screenReaderOnly } from '../../styles/helpers'

export const SkipLink = styled.a`
	${screenReaderOnly};

	&:focus,
	&:focus-visible {
		position: absolute;
		width: auto;
		height: auto;
		clip: auto;
		clip-path: none;
		padding: 0.75rem 1rem;
		border: 0.125rem solid ${theme.color.border.selected};
		margin: 0;
		overflow: visible;
		white-space: normal;
		z-index: 1000;
		background-color: ${theme.color.background.primary};
		color: ${theme.color.text.primary};
		text-decoration: none;
		${theme.typography.labelRegular};
	}
`
